module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_iterators.js
// module id = 55
// module chunks = 1